import { handleResponse } from '../utils';
import axios from '@/util/axios';

export default {
  userTokenLogin(params) {
    // debugger
    return new Promise((resolve, reject) => {
      axios
        .get('/rocheManage/sys/loginByToken?token='+params.token)
        .then(
          (response) => {
            resolve(response);
          },
          (err) => {
            reject(err);
          }
        );
    });
  },

  userCookieLogin(params) {
    // debugger
    return new Promise((resolve, reject) => {
      axios
        .post('/rocheManage/sys/login3', {
          username: params.username,
          password: params.password
        })
        .then(
          (response) => {
            resolve(response);
          },
          (err) => {
            reject(err);
          }
        );
    });
  },
  
  // 获取用户信息
  getUserInfo(params) {
    return new Promise((resolve, reject) => {
      axios.post('/rocheManage/sys/userInfo').then(
        (response) => {
          resolve(response);
        },
        () => {}
      );
    });
  }
  
};



// WEBPACK FOOTER //
// ./src/api/login.js